// Ported verbatim from the mobile app (PrecisionReactNative src/common/assets/images/equipment/eqEllipticalSVG.tsx); generated — regenerate rather than edit.
import * as React from "react";

type Props = {
  fill: string;
  width?: number;
  height?: number;
};

function EqEllipticalSVG(props: Props) {
  const {fill, width = 24, height = 24} = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none">
      <g clip-Path="url(#clip0_513_61447)">
        <path
          d="M8.75 18.75H23L19.25 8.25L15.875 6.75L14.375 2.25"
          stroke="#1F2224"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="square"
        />
        <path
          d="M22.1218 9.12075L20.8555 5.2875L23.3335 1.5"
          stroke="#1F2224"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="square"
        />
        <path
          d="M19.25 15.126L7.92725 11.4461C7.46122 11.3231 6.98195 11.2572 6.5 11.25C5.10761 11.25 3.77226 11.8031 2.78769 12.7877C1.80312 13.7723 1.25 15.1076 1.25 16.5C1.25 17.8924 1.80312 19.2277 2.78769 20.2123C3.77226 21.1969 5.10761 21.75 6.5 21.75H20.75C21.482 21.752 22.1893 21.4851 22.7375 21"
          stroke="#1F2224"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="square"
        />
      </g>
    </svg>
  );
}

export default EqEllipticalSVG;
